module.exports = __webpack_public_path__ + "img/1f9b9-1f3fb.8c22593.svg";